"use client";

import { Card, CardContent } from "@/shared/ui/cards/card";
import { Skeleton } from "@/shared/ui/data-display/skeleton";

export function OrganizationListSkeleton() {
  return (
    <div className="flex-1 space-y-4 pb-16 pt-0">
      {Array.from({ length: 6 }).map((_, index) => (
        <Card
          key={index}
          className="flex flex-col md:flex-row overflow-hidden border border-border/60 bg-card/70"
        >
          {/* Banner Skeleton (Left) */}
          <div className="relative w-full md:w-64 md:shrink-0 h-32 md:h-auto bg-muted">
            <Skeleton className="h-full w-full" />
          </div>

          <CardContent className="flex-1 flex flex-col md:flex-row p-4 gap-4 items-start md:items-center">
            {/* Main Info */}
            <div className="flex-1 min-w-0 space-y-3 w-full">
              <div className="flex items-center gap-2">
                 <Skeleton className="h-6 w-48 rounded" />
              </div>
              
              <div className="space-y-2">
                 <Skeleton className="h-3 w-full" />
                 <Skeleton className="h-3 w-2/3" />
              </div>

              {/* Stats */}
              <div className="flex items-center gap-6 pt-1">
                 <Skeleton className="h-4 w-16" />
                 <Skeleton className="h-4 w-16" />
                 <Skeleton className="h-4 w-16" />
              </div>
            </div>

            {/* Actions & Upcoming */}
            <div className="flex flex-col gap-3 w-full md:w-auto md:min-w-[200px] shrink-0">
               <div className="rounded border border-muted bg-muted/20 p-2">
                 <Skeleton className="h-3 w-20 mb-1" />
                 <Skeleton className="h-4 w-32 mb-1" />
                 <Skeleton className="h-3 w-16" />
               </div>
              
              <Skeleton className="h-9 w-full rounded" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
